import * as React from "react";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { Checkbox, Input, Popup, Icon } from "semantic-ui-react";
import TextareaAutosize from "react-textarea-autosize";
import { useFormContext, useWatch } from "react-hook-form";
import PlayerCardField from "./Fields/PlayerCardField";
import PlayerCardImageField from "./Fields/PlayerCardImageField";
import { useContext } from "react";
import { PlayerCardSettingsContext } from "../../../Contexts";
import { URLS } from "../../../../../utils";

interface HeaderWidgetSettingsProps {
  index: number;
}

const HeaderWidgetSettings: React.FC<HeaderWidgetSettingsProps> = ({ index }) => {
  const { control } = useFormContext<PolymorphicPlayerCard>();
  const bio = useWatch({ control, name: `widgets.${index}.owner.userBio` });
  const bioCharacterCount = bio?.length || 0;
  const bioCharacterLimit = 250;
  const { User } = useContext(PlayerCardSettingsContext);

  const useProfilePhotoUrlLabel = () => {
    var content: React.JSX.Element;
    if (User.isPlayer) {
      content = (
        <div>
          When enabled, uses your{" "}
          <a href={URLS.player.settingsProfile} target="_blank">
            Account's profile image
          </a>
          , with the profile image above as fallback.
        </div>
      );
    } else {
      content = (
        <div>When enabled, uses the Player's Account's profile image, with the profile image above as fallback.</div>
      );
    }
    return (
      <>
        <span>Use Account's Profile Image</span>
        <Popup content={content} hoverable trigger={<Icon name="question circle" style={{ alignSelf: "center" }} />} />
      </>
    );
  };

  return (
    <div className="playerCardWidgetOwner playerCardHeader">
      <div className="mediaContainer">
        <PlayerCardImageField
          index={index}
          fieldName="profileMedia"
          fieldLabel="Profile Image"
          cropShape="round"
          aspect={1 / 1}
        />
        <PlayerCardImageField index={index} fieldName="bannerMedia" fieldLabel="Banner Image" aspect={5 / 2} />
      </div>

      <PlayerCardField
        index={index}
        fieldName="useProfilePhotoUrl"
        fieldLabel={useProfilePhotoUrlLabel()}
        component={Checkbox}
        toggle
      />
      <PlayerCardField
        index={index}
        fieldName="userDisplayName"
        component={Input}
        fieldLabel="Display Name"
        placeholder="Display Name"
        rules={{ required: "This is required." }}
      />
      <PlayerCardField index={index} fieldName="userTitle" component={Input} fieldLabel="Title" placeholder="Title" />
      <PlayerCardField
        index={index}
        fieldName="userSubtitle"
        component={Input}
        fieldLabel="Subtitle"
        placeholder="Subtitle"
      />
      <div className="bioInput">
        <PlayerCardField
          index={index}
          fieldName="userBio"
          component={TextareaAutosize}
          fieldLabel="Bio"
          placeholder="Bio"
          rules={{
            maxLength: { value: bioCharacterLimit, message: `Bio must be less than ${bioCharacterLimit} characters.` },
          }}
          maxRows={7}
        />
        <div className={`characterLimit ${bioCharacterCount > bioCharacterLimit ? "exceeded" : ""}`}>
          {bioCharacterCount}/{bioCharacterLimit} characters
        </div>
      </div>
    </div>
  );
};
export default HeaderWidgetSettings;
